import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AppContext } from '../app/context';

@Injectable({ providedIn: 'root' })
export class EnterpriseReportingGuard implements CanActivate, CanActivateChild {
  readonly appContext = inject(AppContext);
  readonly features = toObservable(this.appContext.features);

  constructor(private store: Store) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.handle(state.url);
  }

  private handle(url: string) {
    if (environment.testing) {
      return of(true);
    }

    return this.features.pipe(map(features => {
      return !!features?.general?.enterpriseReporting;
    }));
  }
}
